export const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'What we fix', href: '#errors' },
  { label: 'How it works', href: '#process' },
  { label: 'Software', href: '#shop' },
  { label: 'Why us', href: '#why' },
  { label: 'Free check', href: '#consultation' },
];

export const HERO_POINTS = [
  'Desktop, Mac and cloud accounting editions supported',
  'Fixed price agreed before any repair begins',
  'Real experts on phone, live chat or callback',
];

export const TRUST_ITEMS = [
  { icon: 'clock', label: 'Same-day response' },
  { icon: 'lock', label: 'Encrypted file handling' },
  { icon: 'wallet', label: 'No-fix, no-fee diagnosis' },
  { icon: 'badge', label: 'Certified bookkeeping experts' },
];

export const ERRORS = [
  {
    icon: 'shield',
    title: 'Company file won’t open',
    body:
      'Corrupted data, failed integrity checks and crashes the moment you open the file. We recover what is there and hand back a stable, verified copy.',
  },
  {
    icon: 'sync',
    title: 'Bank feeds out of sync',
    body:
      'Doubled transactions, missing deposits and a reconciliation difference that never goes away. We match the register to your statement line by line.',
  },
  {
    icon: 'scale',
    title: 'Reports that don’t add up',
    body:
      'Balance Sheet out of balance, opening balances that changed by themselves or a closed year that moved. We trace the entry and correct the totals.',
  },
  {
    icon: 'server',
    title: 'Multi-user & network errors',
    body:
      'Hosting mode conflicts, database manager stopped, or firewall rules blocking other workstations from the shared company file.',
  },
  {
    icon: 'receipt',
    title: 'Payroll & tax form problems',
    body:
      'Paychecks that will not post, stale tax tables, W-2 and 1099 mapping errors and year-end close entries that need fixing before you file.',
  },
  {
    icon: 'users',
    title: 'Customer & vendor balances off',
    body:
      'Payments not applied to invoices, credits sitting on the wrong account and aging reports that disagree with the ledger.',
  },
];

export const STEPS = [
  {
    number: '1',
    title: 'Tell us what happened',
    body:
      'Share the error message, your software edition and what you were doing at the time. Chat or fill the form — it takes two minutes.',
  },
  {
    number: '2',
    title: 'Expert review on a copy',
    body:
      'A certified bookkeeping expert recreates the issue on an encrypted copy of your file, so your live data is never at risk.',
  },
  {
    number: '3',
    title: 'Agree the price, get it fixed',
    body:
      'You approve a fixed quote, we repair and test, then explain exactly what changed so the problem does not come back.',
  },
];

export const STATS = [
  { value: '6+', label: 'Years helping small businesses' },
  { value: '50+', label: 'Bookkeeping experts on the team' },
  { value: 'Fixed', label: 'Price agreed before work' },
  { value: '24/7', label: 'Phone and chat availability' },
];

export const WHY_POINTS = [
  {
    icon: 'badge',
    title: 'Real experts, real answers',
    body:
      'Your case is handled by someone who knows accounting as well as the software — not a scripted call queue.',
  },
  {
    icon: 'clock',
    title: 'Fast turnaround',
    body:
      'Most files are looked at within hours. Payroll and tax deadlines automatically get priority.',
  },
  {
    icon: 'lock',
    title: 'Your data stays safe',
    body:
      'We only work on encrypted copies, keep a restore point for every change and delete the working copy once you sign off.',
  },
  {
    icon: 'wallet',
    title: 'No surprise invoices',
    body:
      'The price you approve is the price you pay. If we can’t find the cause, you don’t pay for the diagnosis.',
  },
];

export const ALL_IN_ONE = [
  {
    heading: 'Tax & compliance',
    items: [
      'Business and individual tax filing support',
      'Sales tax setup and filing guidance',
      'Year-end paperwork that matches your books',
    ],
  },
  {
    heading: 'Everyday bookkeeping',
    items: [
      'Recording daily sales, bills and expenses',
      'Payroll processing and employer filings',
      'Monthly statements you can actually use',
    ],
  },
  {
    heading: 'Planning & growth',
    items: [
      'Cash-flow reports and simple forecasts',
      'Support when applying for business finance',
      'Advice on add-on tools that fit your setup',
    ],
  },
];

export const PRODUCTS = [
  {
    id: 'standard-plus-2023',
    name: 'Ledger Standard Plus 2023 — 1 Year Subscription',
    edition: 'Standard Plus',
    year: '2023',
    image: '/images/box-standard.webp',
    was: '$849.99',
    now: '$429.99',
    badge: 'Popular',
  },
  {
    id: 'business-2021',
    name: 'Books Desk Business 2021 — Perpetual Licence',
    edition: 'Business',
    year: '2021',
    image: '/images/box-business.webp',
    was: '$1,495.99',
    now: '$899.99',
    badge: 'Download',
  },
  {
    id: 'mac-2023',
    name: 'Books Desk Mac Edition 2023 — Perpetual Licence',
    edition: 'Mac Edition',
    year: '2023',
    image: '/images/box-mac.webp',
    was: '$919.99',
    now: '$499.99',
    badge: 'Mac',
  },
  {
    id: 'professional-2021',
    name: 'Ledger Professional 2021 Advisor — Perpetual Licence',
    edition: 'Professional',
    year: '2021',
    image: '/images/box-professional.webp',
    was: '$699.99',
    now: '$599.99',
    badge: 'Advisor',
  },
  {
    id: 'professional-plus-2023',
    name: 'Ledger Professional Plus 2023 — 1 Year Subscription',
    edition: 'Professional Plus',
    year: '2023',
    image: '/images/box-professional.webp',
    was: '$799.99',
    now: '$649.99',
    badge: 'Subscription',
  },
  {
    id: 'standard-2021',
    name: 'Ledger Standard 2021 — Perpetual Licence',
    edition: 'Standard',
    year: '2021',
    image: '/images/box-standard.webp',
    was: '$649.99',
    now: '$399.99',
    badge: 'Download',
  },
];

export const CONSULTATION_POINTS = [
  'Free look at the error you are facing today',
  'Plain-English summary you can share with your accountant',
  'Edition and upgrade advice before you buy or renew',
  'Chat or form — no obligation at all',
];

export const VERSION_OPTIONS = [
  'Desktop Standard',
  'Desktop Professional',
  'Desktop Business',
  'Desktop Mac Edition',
  'Cloud / Online edition',
  'Not sure',
];

export const TOPIC_OPTIONS = [
  'Error message or crash',
  'Company file repair',
  'Bank feed / reconciliation',
  'Payroll or tax forms',
  'Buying a licence',
  'Something else',
];

export const FOOTER_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Contact', to: '/contact' },
  { label: 'FAQs', to: '/faqs' },
];

export const POLICY_LINKS = [
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms of Service', to: '/terms-of-service' },
  { label: 'Refund Policy', to: '/refund-policy' },
  { label: 'Return Policy', to: '/return-policy' },
  { label: 'Delivery Policy', to: '/delivery-policy' },
  { label: 'Cookie Policy', to: '/cookie-policy' },
  { label: 'Authenticity', to: '/authenticity' },
  { label: 'Disclaimer', to: '/disclaimer' },
];

export const FAQS = [
  {
    q: 'How do I talk to an expert right away?',
    a: 'Call +1 855-483-6922 at any hour, open live chat on this page, or send the form if you prefer a written reply.',
  },
  {
    q: 'How quickly will you respond?',
    a: 'Requests sent on a working day get a reply the same day. Weekend and holiday messages are answered first thing the next working morning.',
  },
  {
    q: 'Do I pay anything for the first check?',
    a: 'No. We review what you send, explain the likely cause and what a fix involves. You only pay once you approve a fixed quote.',
  },
  {
    q: 'Will you change my live company file?',
    a: 'Never without a backup. All diagnosis happens on an encrypted copy with a restore point for every change, so your live books stay untouched.',
  },
  {
    q: 'Are the licences you sell genuine?',
    a: 'Yes. Every licence is issued by the software publisher with its own product key and official download. Our Authenticity page explains how to verify it.',
  },
  {
    q: 'Can you help with cloud accounting too?',
    a: 'Yes — desktop Standard, Professional, Business and Mac editions as well as cloud versions, including moving data between desktop and online.',
  },
];
